export default {
	methods: {
		create_table(payload) {
			const table = document.createElement('table')
			payload.forEach( i => table.appendChild(i))
			return table
		},

		create_row(payload) {
			const tr = document.createElement('tr')

			payload.forEach( i => {
				const td = document.createElement('td')
				td.setAttribute('align', 'center')
				if ( typeof i == 'object') td.appendChild(i)
				else td.innerText = i
				tr.appendChild(td)
			});

			return tr
		},

		create_blockquote(payload) {
			const div = document.createElement('div')
			div.style.marginTop = "15px"

			const h3 = document.createElement('h3')
			h3.innerText = payload.title

			const blockquote = document.createElement('blockquote')
			blockquote.innerText = payload.content

			div.appendChild(h3)
			div.appendChild(blockquote)

			return div;
		},
	}
}